"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateAlmeSessionData = exports.GetAlmeSessionData = exports.ClearAlmeSessionData = exports.CookieAlmeSessionDataLoader = exports.almeSessionCookieName = void 0;
var CookieLoader_1 = require("@alme/storage-ts/CookieLoader");
var AlmeSessionDataLoaderBase_1 = require("./AlmeSessionDataLoaderBase");
exports.almeSessionCookieName = "almeSession";
var CookieAlmeSessionDataLoader = /** @class */ (function (_super) {
    __extends(CookieAlmeSessionDataLoader, _super);
    function CookieAlmeSessionDataLoader(storageLoader, logger) {
        var _this = this;
        if (!storageLoader) {
            storageLoader = new CookieLoader_1.CookieLoader(exports.almeSessionCookieName);
        }
        _this = _super.call(this, storageLoader, logger) || this;
        return _this;
    }
    return CookieAlmeSessionDataLoader;
}(AlmeSessionDataLoaderBase_1.AlmeSessionDataLoaderBase));
exports.CookieAlmeSessionDataLoader = CookieAlmeSessionDataLoader;
var cookieSessionDataLoader = new CookieAlmeSessionDataLoader();
/**
 * Clears Alme session data stored in the cookie.
 */
exports.ClearAlmeSessionData = cookieSessionDataLoader.ClearAlmeSessionData.bind(cookieSessionDataLoader);
/**
 * Returns AlmeSessionData stored in the cookie.  If no stored session data exists this stores and returns new random session data.
 *
 * @throws SecurityError if cookies are disabled
 */
exports.GetAlmeSessionData = cookieSessionDataLoader.GetAlmeSessionData.bind(cookieSessionDataLoader);
/**
 * Updates Alme session data stored in the cookie.
 *
 * @throws cookie exceptions
 */
exports.UpdateAlmeSessionData = cookieSessionDataLoader.UpdateAlmeSessionData.bind(cookieSessionDataLoader);
//# sourceMappingURL=CookieAlmeSessionDataLoader.js.map